import React from 'react'
import { useRouter } from 'next/router'
import Fallback from '../../components/Fallback'

export default function useFallback() {
  const router = useRouter()

  return router.isFallback ? <Fallback /> : null
}
